import { Dispatch } from 'react';
import { ErrorObject } from 'src/containers/client-assessment/types';
import PersonalDetails from './PersonalDetails';
import Address from './Address';

type Props = {
  code?: string;
  selectedQuestionId?: string;
  questionnaireValue: any;
  setQuestionnaireValue: Dispatch<any>;
  error: ErrorObject;
  setError: Dispatch<ErrorObject>;
};

function Custom({
  code = 'address_stuff',
  selectedQuestionId = '',
  questionnaireValue,
  setQuestionnaireValue,
  error,
  setError,
}: Props) {
  return (
    <>
      {(() => {
        switch (code) {
          case 'address_stuff':
            return (
              <Address
                selectedQuestionId={selectedQuestionId}
                questionnaireValue={questionnaireValue}
                setQuestionnaireValue={setQuestionnaireValue}
                error={error}
                setError={setError}
              />
            );
          case 'personal_stuff':
            return <PersonalDetails code="" />;
          default:
            return <></>;
        }
      })()}
    </>
  );
}

export default Custom;
